import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    resources: {
        value: [],
        config: {
            name: {
                label: "Название",
                inputProps: { name: "name" },
                required: true,
                validators: [requiredField],
            },
            link: {
                label: "Ссылка",
                inputProps: { name: "link" },
                required: true,
                validators: [requiredField],
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
